var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import { defineMessages, useIntl } from 'react-intl';
import CheckboxMenu from './CheckboxMenu';
var messages = defineMessages({
    SearchFilters: {
        id: 'SearchFilters',
        defaultMessage: 'Search filters',
    },
});
var isSelectAllItem = function (id) { return id.toLowerCase() === 'selectall'; };
var CheckboxDropdownMenu = React.forwardRef(function (_a, ref) {
    var open = _a.open, onClose = _a.onClose, rootCloseEvent = _a.rootCloseEvent, bsRole = _a.bsRole, items = _a.items, onItemChanged = _a.onItemChanged, rest = __rest(_a, ["open", "onClose", "rootCloseEvent", "bsRole", "items", "onItemChanged"]);
    var formatMessage = useIntl().formatMessage;
    var _b = useState(''), searchText = _b[0], setSearchText = _b[1];
    var searchInputRef = useRef(null);
    useEffect(function () {
        if (!open) {
            setSearchText('');
        }
    }, [open]);
    useEffect(function () {
        if (open && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [open]);
    var selectAllItem = useMemo(function () { return items.find(function (item) { return isSelectAllItem(item.id); }); }, [items]);
    var regularItems = useMemo(function () { return items.filter(function (item) { return !isSelectAllItem(item.id); }); }, [items]);
    var filteredItems = useMemo(function () {
        if (!searchText.trim())
            return items;
        var search = searchText.trim().toLowerCase();
        var matched = regularItems.filter(function (item) { return item.label.toLowerCase().includes(search); });
        if (!selectAllItem)
            return matched;
        // When searching, derive selectAll state from whether all visible items are selected
        var allVisibleSelected = matched.length > 0 && matched.every(function (i) { return i.selected; });
        return __spreadArray([__assign(__assign({}, selectAllItem), { selected: allVisibleSelected })], matched, true);
    }, [items, regularItems, selectAllItem, searchText]);
    var handleItemChanged = function (item, selected) {
        if (isSelectAllItem(item.id) && searchText.trim()) {
            var visibleIds = filteredItems.filter(function (i) { return !isSelectAllItem(i.id); }).map(function (i) { return i.id; });
            onItemChanged(item, selected, visibleIds);
        }
        else {
            onItemChanged(item, selected);
        }
    };
    return (_jsx(RootCloseWrapper, __assign({ disabled: !open, onRootClose: function (e) { return onClose(e, { source: 'rootClose' }); }, event: rootCloseEvent, ref: ref }, { children: _jsxs("div", __assign({ className: "dropdown-menu checkbox-dropdown-searchable" }, { children: [_jsx("div", __assign({ className: "checkbox-dropdown-search" }, { children: _jsx("input", { ref: searchInputRef, type: "text", value: searchText, onChange: function (e) { return setSearchText(e.target.value); }, placeholder: formatMessage(messages.SearchFilters), onClick: function (e) { return e.stopPropagation(); } }) })), _jsx("div", __assign({ className: "checkbox-dropdown-list" }, { children: _jsx(CheckboxMenu, __assign({}, rest, { items: filteredItems, onItemChanged: handleItemChanged })) }))] })) })));
});
export default CheckboxDropdownMenu;
